export const INACTIVE_USER_RESPONSE_CODE = 423;
export const INACTIVE_USER_EVENT = "ronspot:inactive-user";
export const DEFAULT_INACTIVE_USER_MESSAGE =
  "This user is currently inactive. If this seems incorrect, please contact your Ronspot administrator.";

export const isInactiveUserResponse = (payload) =>
  payload?.Data?.ResponseCode === INACTIVE_USER_RESPONSE_CODE;

export const dispatchInactiveUserEvent = (payload) => {
  if (typeof window === "undefined") return;

  const message = payload?.Data?.ErrorMessage || DEFAULT_INACTIVE_USER_MESSAGE;

  window.dispatchEvent(
    new CustomEvent(INACTIVE_USER_EVENT, {
      detail: {
        title: "Information",
        message,
      },
    })
  );
};

export const clearSessionAndGoToLogin = () => {
  sessionStorage.clear();
  localStorage.clear();
  window.location.href = "/login";
};
